import { Redirect } from "expo-router";

/**
 * Root route. Delegates everything to the (drawer) AuthGate, which decides
 * whether to show the login screen, the onboarding flow, or chat.
 */
export default function IndexRedirect() {
  return <Redirect href="/(drawer)/chat" />;
}
